import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
  },
  reducers: {
    addToCart: (state, action) => {
      const { _id, selectedVariant, quantity, isUpdate } = action.payload;
      
      // Find if item with same ID AND same grammage exists
      const existingItemIndex = state.items.findIndex(
        (item) => item._id === _id && item.selectedVariant.grammage === selectedVariant.grammage
      );

      if (existingItemIndex >= 0) {
        if (isUpdate) {
          // If coming from Cart page (+/- buttons), set the exact number
          state.items[existingItemIndex].quantity = quantity;
        } else {
          // If coming from Product page, ADD the new quantity to existing
          state.items[existingItemIndex].quantity += quantity;
        }
      } else {
        // If it's a new item, push it to the array
        state.items.push(action.payload);
      }
    },
    removeFromCart: (state, action) => {
      // Logic to remove by ID (and ideally grammage)
      state.items = state.items.filter(item => item._id !== action.payload);
    },
    clearCart: (state) => {
      state.items = [];
    }
  },
});

export const { addToCart, removeFromCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer;